import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MediumEditorComponent } from './medium-editor.component';

@NgModule({
  imports: [CommonModule],
  exports: [MediumEditorComponent],
  declarations: [MediumEditorComponent],
  providers: [],
})
export class MediumEditorModule {}
